import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';
import API_CONSTRUCTOR from '../../models/api-model';
import { toast } from 'sonner';

export const ApproveCommitmentDialog = ({ open, onClose, onSuccess, commitmentId }) => {
  const [notes, setNotes] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      setLoading(true);
      
      const api = API_CONSTRUCTOR();
      await api.put(`/commitments/${commitmentId}/approve`, {
        notes: notes || undefined
      });
      
      toast.success('Commitment approved successfully');
      setNotes('');
      onSuccess();
    } catch (err) {
      console.error('Error approving commitment:', err);
      toast.error(err.response?.data?.error || 'Failed to approve commitment');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <form onSubmit={handleSubmit}>
          <DialogHeader>
            <DialogTitle>Approve Investment Commitment</DialogTitle>
            <DialogDescription>
              This will approve the investor's commitment and notify them. You can add optional notes for the investor.
            </DialogDescription>
          </DialogHeader>

          <div className="py-4">
            <Label htmlFor="notes">Notes for Investor (Optional)</Label>
            <Textarea
              id="notes"
              placeholder="Any additional information or instructions for the investor..."
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              className="mt-2"
              rows={4}
            />
          </div>

          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose} disabled={loading}>
              Cancel
            </Button>
            <Button type="submit" disabled={loading} className="bg-green-600 hover:bg-green-700">
              {loading ? 'Approving...' : 'Approve Commitment'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ApproveCommitmentDialog;
